<template>
  <div class="mt-6 px-4">
    <div class="bg-white p-2 shadow-md rounded">
      <div class="w-full overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
          <thead>
            <TableHeaderRow />
          </thead>
          <tbody>
            <TableBodyRow
              v-for="(entry, index) in currentTab.entries"
              :key="index"
              :entry="entry"
            />
            <tr v-if="!currentTab.entries.length" class="text-xl text-gray-700">
              <td
                :colspan="nColumns"
                class="py-4 px-6 border-b border-gray-200 text-center"
              >
                No se han encontrado resultados
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TableHeaderRow from "@/components/TableHeaderRow";
import TableBodyRow from "@/components/TableBodyRow";

export default {
  components: {
    TableHeaderRow,
    TableBodyRow,
  },
  computed: {
    ...mapGetters(["currentTab", "currentTabHasOptions"]),
    nColumns() {
      return (
        this.currentTab.headers.length +
        this.currentTab.deleteEntriesAllowed +
        this.currentTabHasOptions
      );
    },
  },
};
</script>
